import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { SedsBasicButtonModule, SedsIconModule } from 'experian-design-system';
import { ExperianAuthenticationModule } from 'experian-authentication-frontend-components';
import { environment } from './../../../environments/environment';
import { AuthComponent } from './auth.component';

const routes: Routes = [
  {
    
    path: '', 
    component: AuthComponent
  },
];

@NgModule({
  declarations: [
    AuthComponent,
  ],
  imports: [
    ExperianAuthenticationModule.forChild(environment),
    RouterModule.forChild(routes),
    SedsBasicButtonModule,
    SedsIconModule,
    MatDialogModule
  ],
  exports: [
    RouterModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule { }
